function initSlider(){
	$('.room-images').slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: true
	});
	$(".room-images").on("afterChange", function(event, slick, currentSlide){
		$(".counter-rooms").text(parseInt(slick.currentSlide +1) + ' / ' + parseInt(slick.slideCount));	
	});	
	$('.staff-btn-room').click(function(e){
		var $this = $(this);
		e.preventDefault();
		$this.siblings('.shortdesc').slideToggle();
		$this.toggleClass('active').prev().slideToggle().parent().toggleClass('open');
		$this.hasClass('active') ? $this.html('Less Details') : $this.html('More Details');
		$('.copy-side').css('height','auto');
		$('.room-images').css('vertical-align','top');
		setTimeout(function(){
			equalize();
		},500)	
	})
	setTimeout(function() {
		equalize({reset: true});
	}, 500);
	
	var lazyImages = [].slice.call(document.querySelectorAll('.animate-fade') || []);
	var active = false;

	function _intersectionObserver() {
		if (!active) {
			active = true;

			// setTimeout(function () {
				lazyImages.forEach(function (image) {
					var _imageBoundingClientRect = image.getBoundingClientRect();
					if (_imageBoundingClientRect.top <= window.innerHeight && _imageBoundingClientRect.bottom >= 0) {
						if( !image.classList.contains('animate-fade')  ) image.classList.contains('lazyinlinebg') ? image.style.backgroundImage = 'url(' + image.dataset.srcset + ')' : image.src = image.dataset.srcset;

                        if( !image.classList.contains('animate-fade')  ){
                        	image.classList.add('visible');
                        }else{
                            image.classList.add('fade-in');
						}
						lazyImages = lazyImages.filter(function (_image) {
							return image !== _image;
						});
					}

					if (lazyImages.length === 0) {
						document.removeEventListener('scroll', _intersectionObserver);
						window.removeEventListener('resize', _intersectionObserver);
						window.removeEventListener('orientationchange', _intersectionObserver);
					}

					active = false;
				});
			// }, 0);
		}
	}

	if (lazyImages.length > 0) {
		document.addEventListener('scroll', _intersectionObserver);
		window.addEventListener('resize', _intersectionObserver);
		window.addEventListener('orientationchange', _intersectionObserver);
	}

	_intersectionObserver();

}
// Func = limiting Scope for this file

function _get_form_token(){
	$.get(
		site_url + '/ajax/functions.php?operation=_get_form_token',
		function(resp) {
			$("input[name=_token][type=hidden]").each( function(){
				this.value = resp
			})		
		}		
	);
}


(function(){

	_get_form_token();

	function resizeWindow(){
		setTimeout(function() {
			equalize();
		}, 500);
	}
	function scrollDown(){
		let top = $(document).scrollTop();		
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();		

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
			var top = $(document).scrollTop();		
			if (top > 100) {
				$('#header').addClass('scroll');
			} else {				
				// location.pathname == '/seven-stars-resort/' ? $('#header').removeClass('scroll') : $('header').addClass('scroll');
				$('#header').removeClass('scroll')
			}
			var subtop = ($('#top-content').height() - $('#header').height()) + 10;
			if ($(this).scrollTop() > subtop) {
				$('.sub-menu').addClass('navbar-fixed');
			} else {
				$('.sub-menu').removeClass('navbar-fixed');
			};	
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Home page scroll down arrow. If present.
		$('.arrow-home').click(function(event) {
			$('body, html').animate({
				scrollTop: $(window).height()-$('header').outerHeight()*2},
				800, 'easeOutExpo');
		});

		//home slider animation
		if($('body#home').length > 0){
			setTimeout(function(){
				$('#home .top-content').addClass('shown');
			}, 1000)
		} else{ 
			setTimeout(function(){
				$('#top-content').addClass('shown');
			}, 1000)
		};

		// fancybox for youtube video 
		$(".homepage-video").on('click', function(event) {
			event.preventDefault(); 
			$.fancybox({
				'type' : 'iframe',
				// hide the related video suggestions and autoplay the video
				'href' : this.href.replace(new RegExp('watch\\?v=', 'i'), 'embed/') + '?rel=0&autoplay=1',
				'overlayShow' : true,
				'centerOnScroll' : true,
				'speedIn' : 100,
				'speedOut' : 50,
				'allowfullscreen':true,
				'width'         : '600px',
				'height'         : '350px',
				'iframe' : {
					preload: false
				}
			});
		});

		$('.awards-accolades .awards-block').slick({
			arrows: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				accessibility:false,
				responsive: [
				{
					breakpoint: 768,
					settings: {
					arrows: true,
					slidesToShow: 3
					}
				},
				{
					breakpoint: 480,
					settings: {
					arrows: false,
					slidesToShow: 1
					}
				}
				]
		});

		$('.accommodations .img_slider').slick({
			arrows:true,
			dots:false,
			autoplay:false,
			autoplaySpeed: 5000,
			accessibility:false
		});

		$('.benefits-accolades .benefits-block').slick({
			arrows: true,
			appendArrows: '.benefits-arrows',
			slidesToShow: 2,
			slidesToScroll: 2,
			vertical: true,
			verticalSwiping: true,
			accessibility:false
		});
		
		$(".benefits-accolades .benefits-block").on("afterChange", function(event, slick, currentSlide){
			if(slick.slideCount%2 == 0){
				$(".counter-benefits").text(parseInt((slick.currentSlide /2)+1) + ' / ' + parseInt(slick.slideCount/2));
			}else{
				$(".counter-benefits").text(parseInt((slick.currentSlide /2)+1) + ' / ' + parseInt((slick.slideCount/2)+1));
			}			
		});	
		$(".blog-images").on("afterChange", function(event, slick, currentSlide){
			$(".counter-blog").text(parseInt(slick.currentSlide +1) + ' / ' + parseInt(slick.slideCount));	
		});	
		//Accommodations amenities
		// $('.amenities').wrapInner('<div class="container"></div>');
		// $('body.accommodations .amenities').insertBefore('ul.accommodations');

		/* MENU FUNCTION */
		// variables used in this function
		const burger = $("#menuTrigger");
		const fullMenu = $(".floating-menu");

		burger.click(function(ev){
			ev.preventDefault();
			fullMenu.animate({
				top: 0,
				opacity: 1
			},300, function(){
				$(this).addClass('open');
			});
			window.onscroll=function(){window.scrollTo(window.scrollX, window.scrollY);};

		})
		fullMenu.find('.close').click(function(ev){
			ev.preventDefault();
			fullMenu.animate({
				top: "-110vh",
				opacity: 0
			},300,function(){
				$(this).removeClass('open');
			});
			window.onscroll=function(){};
		});

		/* Check In FUNCTION */
		// variables used in this function
		const checkButton = $("#buttonTrigger");
		const fullCheck = $(".floating-checkin");

		checkButton.click(function(ev){
			ev.preventDefault();
			fullCheck.animate({
				top: 0,
				opacity: 1
			},300, function(){
				$(this).addClass('open');
			});
			window.onscroll=function(){window.scrollTo(window.scrollX, window.scrollY);};

		})
		fullCheck.find('.close').click(function(ev){
			ev.preventDefault();
			fullCheck.animate({
				top: "-110vh",
				opacity: 0
			},300,function(){
				$(this).removeClass('open');
			});
			window.onscroll=function(){};
		});
		///Map Selection Pin
		let timePlane;
		let timeRoute;
		if($('#home').length > 0){
			$('#home .main-content .home-map .list ul li').click(function(){
				let pin_map = $( this ).attr( "data-pin" );
				$('#home .main-content .home-map .list ul li').removeClass('active');
				$('#home .main-content .home-map .pins ul li').removeClass('active');
				$('#home .main-content .home-map #travel-route img').remove();
				$(this).addClass('active');
				$('#home .main-content .home-map .pins ul li#pin-'+pin_map).addClass('active');
				clearTimeout(timePlane);
				timePlane = setTimeout(function(){
					$('#home .main-content .home-map #travel-route').load('assets/images/map/route-map-'+pin_map+'.svg');	
					clearTimeout(timeRoute);							
					timeRoute = setTimeout(function(){ $('#plane-'+pin_map).animate ({opacity:0}, 200 ); }, 4800);
				},500)					
			});

			$('#home .main-content .home-map .pins ul li').click(function(){
				let pin_map = $( this ).attr( "data-pin" );
				$('#home .main-content .home-map .pins ul li').removeClass('active');
				$('#home .main-content .home-map .list ul li').removeClass('active');
				$('#home .main-content .home-map #travel-route img').remove();
				$(this).addClass('active');		
				$('#home .main-content .home-map .list ul li#mapa-'+pin_map).addClass('active');	
				setTimeout(function(){
					$('#home .main-content .home-map #travel-route').load('assets/images/map/route-map-'+pin_map+'.svg');					
					setTimeout(function(){ $('#plane-'+pin_map).animate ({opacity:0}, 200 ); }, 4800);
				},500)	
			});
		}
		$('#booking-form .airport-select').hide();
		$('.hotel-air').click(function () {
            $('.hotel-h').prop( "checked", false );
            $('.hotel-air').prop( "checked", true );
			$("#booking-form .airport-select").fadeIn(1000);
            $('input[name=showhotel]').val('N');
        });
        $('.hotel-h').click(function () {
            $('.hotel-h').prop( "checked", true );
            $('.hotel-air').prop( "checked", false );
			$('#booking-form .airport-select').fadeOut(1000);
            $('input[name=showhotel]').val('Y');
        });

		//Terms Toggle
		showContent($('.toggle-terms'), $('.terms-container'),'active');
		//Toggle Blog
		$('.staff-btn').click(function(e){
			var $this = $(this);
			e.preventDefault();
			$this.siblings('.shortdesc').slideToggle();
			$this.toggleClass('active').prev().slideToggle().parent().toggleClass('open');
			$this.hasClass('active') ? $this.html('Less Details') : $this.html('More Details');
			$('.copy-side').css('height','auto');
			$('.blog-images').css('vertical-align','top');
			setTimeout(function(){
				equalize();
			},500)	
		})

		$('.request-btn').click(function() {
			var tab = $(this).attr('href');
			
			if($(this).hasClass('expanded-form')) {
				$(tab).hide();
				$(this).removeClass('expanded-form');
			} else {
				$(tab).show();
				$(this).addClass('expanded-form');
			}
		});

		//Event Tracking
			

			function validateBooking() {
				var error = false;
				if ($('select[name=hotel]').val() === '') {
					$('#property').css('border', '1px solid red');
					error = true;
				}

				if ($('.room-air').hasClass('active')) {
					if ($('#airport2 :selected').val() == '') {
						$('#airport2').parent().css('border', '1px solid red');
						error = true;
					}
				}
				return (error) ? false : true;
			}
			// $('.book-now').on('click', function(e) {
			// 	e.preventDefault();
			// 	var destinationUrl = $(this).attr('href');
			// 	ga(function(tracker) {
				//     	var linker = new window.gaplugins.Linker(tracker);
				//     	var output = linker.decorate(destinationUrl, true);
					//  	ga('send', 'event', 'reservation', 'click', 'book now');
				//     	window.open(output, '_blank');
			//       	});
			//    });
			

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 7);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});

		$( "#CheckIn_Card" ).datepicker({});

		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		$('body#map #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		$('body#map #content').prepend('<a class="btn map-list hidden" href="/turks-and-caicos-islands/ada-map">Click Here for Accessible List of Attractions</a>');		
		
	});

	// $(window).on('load', function() {

		
	// });

}());